module.exports = __webpack_public_path__ + "static/media/credins.be19aa6e.png";